"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Theme = require("../Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: auto;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: absolute;\n  display: block;\n  width: 3em;\n  height: 3em;\n  left: 50%;\n  top: 50%;\n  transform: translate(-1.5em, -1.5em);\n  opacity: 0;\n  transition: opacity 0.2s ease-out;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  height: auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: relative;\n  display: block;\n  width: 100%;\n  border: none;\n\n  &:focus {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n\n  &:hover .hw-video-thumbnail-overlay,\n  &:focus .hw-video-thumbnail-overlay {\n    opacity: 1;\n  }\n\n  & rect {\n    fill: ", ";\n    fill-opacity: 0.8;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Videothumbnail = _styledComponents.default.button(_templateObject(), function (props) {
  return props.theme.focusIndicator;
}, function (props) {
  return props.theme.focusIndicatorOffset;
}, function (props) {
  return props.theme.colorPrimary;
});

var VideoThumbnailImage = _styledComponents.default.img(_templateObject2());

var VideoThumbnailOverlay = _styledComponents.default.span(_templateObject3());

var VideoThumbnailIcon = _styledComponents.default.svg(_templateObject4());

var VideoThumbnail = /*#__PURE__*/function (_Component) {
  _inherits(VideoThumbnail, _Component);

  function VideoThumbnail() {
    _classCallCheck(this, VideoThumbnail);

    return _possibleConstructorReturn(this, _getPrototypeOf(VideoThumbnail).apply(this, arguments));
  }

  _createClass(VideoThumbnail, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          src = _this$props.src,
          alt = _this$props.alt,
          onThumbnailClick = _this$props.onThumbnailClick,
          theme = _this$props.theme,
          otherProps = _objectWithoutProperties(_this$props, ["title", "src", "alt", "onThumbnailClick", "theme"]);

      var thumbSrc = src.replace('_640x360.jpg', '.jpg').replace('.jpg', '_640x360.jpg'); // Normalize to correct aspect ratio

      return _react.default.createElement(Videothumbnail, _extends({
        type: "button",
        className: "hw-video-thumbnail",
        onClick: onThumbnailClick,
        theme: theme
      }, otherProps), _react.default.createElement(VideoThumbnailImage, {
        className: "hw-video-thumbnail-image",
        src: thumbSrc,
        alt: alt || "open video: ".concat(title)
      }), _react.default.createElement(VideoThumbnailOverlay, {
        className: "hw-video-thumbnail-overlay"
      }, _react.default.createElement(VideoThumbnailIcon, {
        focusable: "false",
        "aria-hidden": "true",
        role: "presentation",
        className: 'hw-video-thumbnail-icon',
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, _react.default.createElement("g", null, _react.default.createElement("rect", {
        x: "0",
        y: "0",
        width: "40",
        height: "40"
      }), _react.default.createElement("g", {
        transform: "translate(12.5, 12.5)"
      }, _react.default.createElement("polygon", {
        points: "5 3.125 5 11.875 11.875 7.5",
        fill: "#fafafa"
      }))))));
    }
  }]);

  return VideoThumbnail;
}(_react.Component);

VideoThumbnail.propTypes = {
  title: _propTypes.default.string,
  src: _propTypes.default.string.isRequired,
  alt: _propTypes.default.string,
  onThumbnailClick: _propTypes.default.func,
  theme: _propTypes.default.shape({
    colorPrimary: _propTypes.default.string,
    focusIndicator: _propTypes.default.string,
    focusIndicatorOffset: _propTypes.default.string
  })
};
VideoThumbnail.defaultProps = {
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(VideoThumbnail);

exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/VideoThumbnail/index.js